import { forwardRef } from "react";
import styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A toast component that positions its children bottom center of the map
 */
const Toast = /*#__PURE__*/forwardRef((_ref, forwardRef) => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Container, {
    ref: forwardRef,
    children: children
  });
});
Toast.displayName = "Toast";
const Container = styled.div.withConfig({
  displayName: "Toast__Container",
  componentId: "sc-1xyalgu-0"
})(["position:fixed;z-index:99999;bottom:80px;left:35%;@media (min-width:", "px){position:absolute;left:45%;bottom:60px;}display:flex;align-items:center;justify-content:center;padding:0 7px;border-radius:16px;min-height:32px;background:", ";"], props => props.theme.sm, p => p.theme.textLight);
export default Toast;